import RoutesMap from "../../route_control/RouteControl"
import {
    ShopCategoryList,
    ShopSubCategoryList,
    ShopProductList,
} from "../../pages/shop"

export const ShopImport = {
    RoutesMap,
    ShopCategoryList,
    ShopSubCategoryList,
    ShopProductList,
}
